import{i as o}from"../../_virtual/isBuffer.js";import r from"./_root.js";import e from"./stubFalse.js";!function(o,s){var f=r,i=e,t=s&&!s.nodeType&&s,p=t&&o&&!o.nodeType&&o,m=p&&p.exports===t?f.Buffer:void 0,u=(m?m.isBuffer:void 0)||i;o.exports=u}(o,o.exports);
//# sourceMappingURL=isBuffer.js.map
